import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  visible: PropTypes.bool,
};

const DesignerViewSecondaryA = ({ className, visible }) => {
  const classes = classNames({
    [className]: !!className,
  });

  if (!visible) {
    return null;
  }

  return (
    <div className={classes}>
      <p>
        Anything can be added here, any type of control, whatever is necessary.
        This component is just an example structure, it is not part of the main
        DesignEditor API.
      </p>
    </div>
  );
};

DesignerViewSecondaryA.propTypes = propTypes;

export default DesignerViewSecondaryA;
